import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "text-sm font-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_6 = {
  key: 0,
  class: "px-4 pb-4 pt-0 flex gap-2"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-primary-500 text-sm font-semibold cursor-pointer" }

import { PropType, computed } from 'vue'
import { NotificationData, NotificationType } from './../../lib/types'
import Icon from './../components/Icon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
  notification: {
    type: Object as PropType<NotificationData>,
    required: true
  },

  wrapperClass: {
    type: String,
    default: 'bg-gray-800'
  },

  contentClass: {
    type: String,
    default: 'text-white'
  }
},
  setup(__props) {

const props = __props;



const title = computed(
  (): string => props.notification.title || 'Notification Title'
)

function close() {
  props.notification.deactivate()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-lg pointer-events-auto", __props.wrapperClass])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex gap-2 justify-start items-start p-4", { 'items-center': !__props.notification.description }])
    }, [
      (__props.notification.type === _unref(NotificationType).Error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "error", {}, () => [
              _createVNode(Icon, {
                name: "warn",
                class: "w-6 h-6 min-w-6 text-red-500"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.notification.type === _unref(NotificationType).Warning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "warning", {}, () => [
              _createVNode(Icon, {
                name: "warn",
                class: "w-6 h-6 min-w-6 text-orange-400"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.notification.type === _unref(NotificationType).Success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "success", {}, () => [
              _createVNode(Icon, {
                name: "circle-check-border",
                class: "w-6 h-6 min-w-6 text-green-400"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col gap-2", __props.contentClass])
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(title)), 1),
        (__props.notification.description)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.notification.description), 1))
          : _createCommentVNode("", true)
      ], 2),
      _renderSlot(_ctx.$slots, "close", { close: close }, () => [
        _createVNode(Icon, {
          name: "close",
          class: "w-3 h-3 min-w-3 text-white",
          onClick: close
        })
      ])
    ], 2),
    (__props.notification.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.notification.actions, (action) => {
            return (_openBlock(), _createElementBlock("button", {
              key: action.key,
              onClick: 
          () =>
            action.callback({
              id: __props.notification.id,
              deactivate: __props.notification.deactivate
            })
        
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(action.label), 1)
            ], 8, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})